import {Container, Grid, Hidden, Theme, Typography, useMediaQuery} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {WithTranslation, withTranslation} from 'react-i18next';

import AuditImageMobile from 'src/Assets/Images/audit.png?width=240&quality=100&ignore';
import AuditImage from 'src/Assets/Images/audit.png?width=620&height=370&quality=85&ignore';
import MessageBalloon from 'src/Components/Common/Sections/MessageBalloon';
import {IAnchorable} from 'src/Routes/Pages/IAnchorable';

import {performanceBlockStyles} from './performanceBlockStyles';

const PerformanceBlock = (props: IAnchorable & WithTranslation & WithStyles) => {
	const matchesMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

	return (
		<section className={props.classes.root} id={props.anchor}>
			<Container maxWidth="lg" disableGutters={matchesMobile}>
				<Grid container className={props.classes.grid}>
					<Grid item xs={12} md={4} className={props.classes.imageWrapper}>
						<Hidden xsDown>
							<img src={AuditImage} className={props.classes.auditImage} alt={props.t('audit-alt')} />
						</Hidden>
						<Hidden smUp>
							<img src={AuditImageMobile} className={props.classes.auditImage} alt={props.t('audit-alt')} />
						</Hidden>
					</Grid>
					<Grid item xs={12} md={8}>
						<MessageBalloon arrowOffset={matchesMobile ? 0 : '30%'} className={props.classes.topBalloon}>
							<Typography variant="h4">{props.t('audit-title')}</Typography>
							<Typography variant="body2">{props.t('audit-description')}</Typography>
						</MessageBalloon>
						<MessageBalloon right className={props.classes.bottomBalloon} arrowOffset="10%">
							<Typography variant="body1">{props.t('audit-growth')}</Typography>
						</MessageBalloon>
					</Grid>
				</Grid>
			</Container>
		</section>
	);
};

export default withStyles(performanceBlockStyles)(withTranslation('performance')(PerformanceBlock));
